import { useSearchParams, useNavigate } from "react-router-dom";
import { Box, Card, CardContent, CircularProgress, Typography, TextField, InputAdornment, IconButton, Button } from "@mui/material";
import {  CheckCircle,  LockTwoTone, Visibility, VisibilityOff } from "@mui/icons-material";
import logo from "../../assets/logo.svg";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../store/slices/authSlice";
import { useRef, useState } from "react";
import { verifyEmailAPI } from "../../apis/verifyEmail";

const VerifyEmail = () => {
    // Get token as a query parameter from url
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("Please enter password");
    const token = searchParams.get("token");

    const [isVerified, setIsVerified] = useState(false)
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isTouched = useRef(false)

    // Decode the token (since it’s URL-encoded)
    const decodedToken = decodeURIComponent(token);

    const accountActivationHandler = async () => {
        try {
            setLoading(true);
            isTouched.current = true

            const payload = {
                token,
                password
            }
            const data = await verifyEmailAPI(payload);
            // dispatch(loginSuccess({ user: data.user, tokens: data.tokens, permissions: data?.permissions, subscription: data?.subscription }));
            // navigate("/");
            setIsVerified(true)
            setMessage("Email verification was successfull.")
            setLoading(false);

            setTimeout(() => {
                setLoading(true);
                dispatch(loginSuccess({ 
                    user: data.user, 
                    tokens: data.tokens, 
                    permissions: data?.permissions, 
                    subscription: data?.subscription 
                }));
                navigate("/");
            }, 1000)

        } catch (error) {
            setIsVerified(false)
            setMessage("Failed to verify email" + ": " + error);
            setLoading(false);

        }

    }



    return (
        <Box sx={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#F9FAFB",
            padding: 2
        }}>
            <Card sx={{
                width: {
                    sm: "100%",
                    md: "50%"
                },
                borderRadius: 2,
                boxShadow: 3,
                maxWidth: "560px",
                p: 4
            }}>
                <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4, padding: 4 }}>
                    <img src={logo} alt="Logo" style={{ height: 32 }} />
                    {loading ? (
                        <>
                            <CircularProgress color="primary" />
                            <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center" }}>
                                Please wait while we validate the details.
                            </Typography>
                        </>
                    ) : isVerified ? (
                        <CheckCircle color="success" sx={{ fontSize: 60 }} />
                    ) : (
                        <LockTwoTone color="error" sx={{ fontSize: 60 }} />
                    )}
                    {
                        !loading && <Typography variant="body1" sx={{ fontWeight: 600, textAlign: "center" }} color={isVerified ? "success" : (!isTouched.current ? "textPrimary" : "error")}>
                            {message}
                        </Typography>
                    }

                    {!isVerified && (
                        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <TextField
                                type={showPassword ? 'text' : 'password'}
                                label="Password"
                                placeholder="Create a password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                fullWidth
                                variant="outlined"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" aria-label="toggle password visibility">
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                        '& fieldset': { borderColor: '#e0e0e0' },
                                        '&:hover fieldset': { borderColor: '#b0b0b0' },
                                        '&.Mui-focused fieldset': { borderColor: '#153d7c' }
                                    }
                                }}
                            />
                            <Button
                                type="button"
                                variant="contained"
                                disabled={!password || loading}
                                onClick={accountActivationHandler}
                                sx={{
                                    backgroundColor: '#153d7c',
                                    color: 'white',
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                    py: 1.25,
                                    '&:hover': { backgroundColor: '#153d7c' },
                                    '&:disabled': { backgroundColor: '#bdbdbd', color: 'white' }
                                }}
                            >
                                Activate Account
                            </Button>
                        </Box>
                    )}

                </CardContent>
            </Card>
        </Box>
    )
}

export default VerifyEmail;